import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useWindowSize } from '@websolutespa/bom-mixer-hooks';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';

const Suggestions = () => {
  useWindowSize();
  const app = useLlm(state => state.app);
  const {
    send
  } = useLlmView(state => state.actions);
  const onClick = item => __awaiter(void 0, void 0, void 0, function* () {
    yield send(item.sampleInputText, response => {
      // console.log('Suggestions.onMessage', response.chunks);
    }, response => {
      // console.log('Suggestions.onEnd', response);
    });
  });
  const sampleInputTexts = app === null || app === void 0 ? void 0 : app.contents.sampleInputTexts;
  return jsx(Fragment, {
    children: sampleInputTexts && sampleInputTexts.length > 0 && jsx("section", {
      className: "llm__prompt-suggestions",
      children: jsx("div", {
        className: "llm__suggestions",
        children: sampleInputTexts.map((s, j) => jsx("button", {
          type: "button",
          className: "llm__pill",
          onClick: () => onClick(s),
          children: s.sampleInputText
        }, j))
      })
    })
  });
};

export { Suggestions };
//# sourceMappingURL=suggestions.js.map
